export default __webpack_public_path__ + "static/media/sales-return.4b5b6f30.svg";